import styled, { css } from 'styled-components';
import {
    CloseButton, spaceMixin, Spacer, Text, mediaMixin,
} from '@zillow/constellation';

export const StyledCloseButton = styled(CloseButton)`
    padding: 4px;
`;

export const StyledThumbItem = styled(Spacer)`
    margin-bottom: ${spaceMixin('md')};
    cursor: default;

    ${props => props.disabled && css`
        pointer-events: none;
    `}

    ${mediaMixin('xl', css`
        margin-bottom: ${spaceMixin('xs')};
        cursor: grab;
    `)}

    .ThumbItem-img-container {
        display: flex;
        justify-content: center;
        align-items: center;

        position: relative;
        margin-bottom: ${spaceMixin('sm')};
        height: 125px;
        background-color: #eeeeee;

        .Action.Action-close {
            position: absolute;
            top: ${spaceMixin('sm')};
            right: ${spaceMixin(0.5)};
            background-color: rgba(0, 0, 0, .75);

            svg {
                position: relative;
                fill: white;
            }
        }

        img {
            max-width: 100%;
            max-height: 100%;
        }

        ${mediaMixin('lg', css`
            height: 172px;
        `)}

        ${mediaMixin('xxl', css`
            height: 216px;
        `)}
    }

    .ThumbItem-actions-container {
        display: flex;
        justify-content: center;
    }

    .ThumbItem-caption {
        display: flex;
        align-items: center;

        position: absolute;
        padding: ${spaceMixin('xs')};
        left: 0;
        bottom: 0;
        width: 100%;
        height: 38px;
        background-color: rgba(0, 0, 0, .5);
        overflow: hidden;
        z-index: 1;

        /* mui - extend */
        ${Text} {
            white-space: nowrap;
        }
    }

    .Action {
        margin-right: ${spaceMixin('lg')};
        cursor: pointer;

        &.disabled {
            pointer-events: none;
            color: rgba(0, 106, 255, 0.35);
        }

        &:last-child {
            margin-right: 0;
        }
    }
`;
